import { takeEvery, all } from 'redux-saga/effects';
import {
  GET_PAYMENT_SERVICE_CONF,
  SET_PAYMENT_SERVICE_DATA,
  SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA,
  GET_OCR_SCANNER,
  GET_PAYMENT_SERVICE_CONTACTS,
  GET_FAVORITE_CONTACTS,
  ADD_CONTACT_TO_FAVORITES,
  DELETE_CONTACT_FROM_FAVORITES,
  GET_RECENT_CONTACTS,
  ADD_CONTACT_TO_RECENTS,
  /// Telcel
  GET_AMOUNT_OF_TELCEL_POSPAGO,
  /// user info
  GET_USER_INFO,
  /// payment method
  GET_PAYMENT_METHODS,
  /// commission rules
  GET_COMMISSION_RULES,
  SET_SELECTED_CHIP_VALUES,
  GET_COMMISSION_INFO,
  GET_PLANS,
  EXIST_CARD_SEARS,
  GET_PLANS_CARD_SEARS,
  GET_COORDINATES,
  GET_TRACK_ID,
  SET_TRACK_DATA,
  SET_TRACK_STEPS,
  EXECUTE_TAGGEO,
  GET_MESSENGER_SERVICE,
  GET_TELCEL_LINE_INFORMATION,
  GET_MESSENGER_SERVICE_SEARS,
  GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT,
  GET_APP_SYNC,
  DELETE_ALL_CARDS,
  SET_CAN_R1,
  GET_PHONE_PROFILE,
  CHECK_BALANCE_N2,
} from './actions';
import { GET_HAS_DOMICILIATION, DOMICILIATION_REFERENCE } from './actions/domiciliation';
import { GET_FAVORITOS_REF,DELETE_FAVORITES_REF,ADD_FAVORITES_REF,GET_MESSAGES_FAVORITES_SERVICES,CREATE_TOOLTIP_FAVORITE,GET_TOOLTIP_FAVORITE } from './actions/favoritosRef';
import {GET_PAYMENT_REMINDER,UPDATE_PAYMENT_REMINDER,TOOGLE_PAYMENT_REMINDER,DELETE_PAYMENT_REMINDER} from './actions/payReminder'
import { GET_MESSAGING_SERVICE } from './actions/messaging';
import { FETCH_AMIGO_PAGUITOS_LOAN_DETAILS } from './actions/aploan';
import * as payREminderSagas from './sagas/payReminderSagas'
import * as paymentsSagas from './sagas/paymentsSagas';
import * as domiciliationSagas from './sagas/domiciliationSagas'
import * as favoritosRefSagas from './sagas/favoritosRefSagas'
import * as apLoanSagas from "./sagas/aploan";
import { getMessagingServiceSaga } from './sagas/messaging';
import { transactionWorkerSaga } from './sagas/transactions';

export default function* rootSaga() {
  yield all([
    takeEvery(GET_PAYMENT_SERVICE_CONF, paymentsSagas.sagaGetPaymentServiceConf),
    takeEvery(SET_PAYMENT_SERVICE_DATA, paymentsSagas.sagaSetPaymentServiceData),
    takeEvery(SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA, paymentsSagas.sagaGetPhoneNumber),
    takeEvery(GET_OCR_SCANNER, paymentsSagas.sagaGetOCRScanner),
    takeEvery(GET_PAYMENT_SERVICE_CONTACTS, paymentsSagas.sagaGetPaymentContacts),
    takeEvery(GET_FAVORITE_CONTACTS, paymentsSagas.getFavoriteContactsSaga),
    takeEvery(ADD_CONTACT_TO_FAVORITES, paymentsSagas.addContactToFavorites),
    takeEvery(DELETE_CONTACT_FROM_FAVORITES, paymentsSagas.sagaDeleteFavoriteContact),
    takeEvery(GET_RECENT_CONTACTS, paymentsSagas.getRecentContactsSaga),
    takeEvery(ADD_CONTACT_TO_RECENTS, paymentsSagas.addContactToRecents),
    takeEvery(GET_AMOUNT_OF_TELCEL_POSPAGO, paymentsSagas.sagaGetAmountOfTelcelPospago),
    takeEvery(GET_USER_INFO, paymentsSagas.sagaGetUserInfo),
    takeEvery(GET_PAYMENT_METHODS, paymentsSagas.sagaGetPaymentMethods),
    takeEvery(SET_SELECTED_CHIP_VALUES, paymentsSagas.setSelectedChipValuesSaga), 
    takeEvery(GET_COMMISSION_INFO, paymentsSagas.getCommissionInfo),
    takeEvery(GET_PLANS, paymentsSagas.getPlans), 
    takeEvery(EXIST_CARD_SEARS, paymentsSagas.existCardSears),
    takeEvery(GET_PLANS_CARD_SEARS, paymentsSagas.getPlansCardSearsSaga),
    takeEvery(GET_COORDINATES, paymentsSagas.getCoordinatesUser),
    takeEvery(GET_TRACK_ID, paymentsSagas.sagaGetTrackId),
    takeEvery(SET_TRACK_DATA, paymentsSagas.setTrackData),
    takeEvery(SET_TRACK_STEPS, paymentsSagas.sagaSetTrackSteps),
    takeEvery(EXECUTE_TAGGEO, paymentsSagas.executeTaggeoSaga),
    takeEvery(GET_MESSENGER_SERVICE, paymentsSagas.getMessengerServiceSaga),
    takeEvery(GET_TELCEL_LINE_INFORMATION, paymentsSagas.getTelcelLineInformationSaga),
    takeEvery(GET_MESSENGER_SERVICE_SEARS, paymentsSagas.getMessengerServiceSearsSaga),
    takeEvery(GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT, paymentsSagas.getScheduleTelcelContract),
    takeEvery(GET_HAS_DOMICILIATION, domiciliationSagas.getHasDomiciliationSaga),
    takeEvery(DOMICILIATION_REFERENCE, domiciliationSagas.domiciliationReferenceSaga),
    takeEvery(GET_FAVORITOS_REF, favoritosRefSagas.getFavoriteRefSaga),
    takeEvery(ADD_FAVORITES_REF, favoritosRefSagas.addFavoritesRefSaga),
    takeEvery(DELETE_FAVORITES_REF, favoritosRefSagas.DeleteFavoriteRefSaga),
    takeEvery(GET_TOOLTIP_FAVORITE, favoritosRefSagas.GetFavoriteTooltipSagas),
    takeEvery(CREATE_TOOLTIP_FAVORITE, favoritosRefSagas.CreateFavoriteTooltipSagas),
    takeEvery(GET_MESSAGES_FAVORITES_SERVICES, favoritosRefSagas.getMessagesFavoritesServicesSaga),
    takeEvery(GET_PAYMENT_REMINDER, payREminderSagas.getPaymentReminder),
    takeEvery(UPDATE_PAYMENT_REMINDER, payREminderSagas.updatePaymentReminder),
    takeEvery(TOOGLE_PAYMENT_REMINDER, payREminderSagas.togglePaymentReminder),
    takeEvery(DELETE_PAYMENT_REMINDER, payREminderSagas.deletePaymentReminder),
    takeEvery(GET_APP_SYNC, paymentsSagas.getAppSyncSaga),
    takeEvery(DELETE_ALL_CARDS, paymentsSagas.deleteAllCardsSaga),
    takeEvery(FETCH_AMIGO_PAGUITOS_LOAN_DETAILS,apLoanSagas.fetchAmigoPaguitosLoan),
    takeEvery(GET_MESSAGING_SERVICE, getMessagingServiceSaga),
    takeEvery(SET_CAN_R1, transactionWorkerSaga),
    takeEvery(GET_PHONE_PROFILE, paymentsSagas.getPhoneProfileSaga),
    takeEvery(CHECK_BALANCE_N2, paymentsSagas.checkBalanceN2Saga),
  ]);
}